import EarlyBirdCollegeCard from './EarlyBirdCollegeCard';

export default EarlyBirdCollegeCard;



// WEBPACK FOOTER //
// ./src/components/EarlyBirdCollegeCard/index.js